import z, { ZodType } from "zod";

import type { OrganisationIdUnbranded } from "./organisation.js";
import { UserSchema, type UserUnbranded } from "./user.js";

export type BulkCreateUserRequest = {
  csv: string;
  organisationId: OrganisationIdUnbranded;
};

export type BulkUserCsvRow = {
  name: string;
  email: string;
  shoulder_number: string;
};

export type UpdateUserProfileRequestUnbranded = Pick<
  UserUnbranded,
  "name" | "email" | "shoulderNumber"
>;

export const UpdateUserProfileRequestSchema = UserSchema.pick({
  name: true,
  email: true,
  shoulderNumber: true,
}).brand<"vision-common:UpdateUserProfileRequest">() satisfies ZodType<UpdateUserProfileRequestUnbranded>;

export type UpdateUserProfileRequest = z.infer<
  typeof UpdateUserProfileRequestSchema
>;
